// --------------------------------------------------- wishlist--------------------------------
// Wishlist feature: Add or remove the current product from the wishlist
/////////////// Function to set wish product while website load //////////////
function setWishToProduct() {
  const wishlistButtonArr = document.querySelectorAll(".wishlist_button");
  wishlistButtonArr.forEach((wishBtn) => {
    const cardWrapper = wishBtn.parentElement;
    const title = cardWrapper
      .querySelector(".card__heading")
      .textContent.trim();
    let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
    const isInWishlist = wishlistData.some(
      (item) => item.productTitle === title
    );
    if (isInWishlist) {
      wishBtn.innerHTML =`<svg class="heart-filled" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M26 1H6a1 1 0 0 0-1 1v28a1 1 0 0 0 1.625.781L16 23.28l9.375 7.5A1 1 0 0 0 27 30V2a1 1 0 0 0-1-1z" fill="#000000" opacity="0.5" data-original="#000000"></path>
                </g>
                </svg>`;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setInterval(() => {
    setWishToProduct();
  }, 1000);
});
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".wishlist_button").classList.contains("wishlist_button")
  ) {
    const wishlistButton = e.target.closest(".wishlist_button");
    const cardWrapper = wishlistButton.closest(".card-wrapper");
    const price = cardWrapper
      .querySelector(".price-item--regular")
      .textContent.trim();
    const title = cardWrapper
      .querySelector(".card__heading")
      .textContent.trim();
    const img_url = cardWrapper.querySelector(".card__media img").src.trim();
    const product_url = cardWrapper.querySelector(".card__heading a").href.trim();
    const pdpData = {
      productTitle: title,
      productImg: img_url,
      productPrice: price,
      productUrl: product_url,
    };
    let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
    const isAlreadyInWishlist = wishlistData.some(
      (item) => item.productTitle === pdpData.productTitle
    );
    // // console.log(pdpData);
    if (!isAlreadyInWishlist) {
      wishlistData.push(pdpData);
      localStorage.setItem("wishlist", JSON.stringify(wishlistData));
      // alert('Product added to wishlist:', pdpData.productTitle);
      wishlistButton.innerHTML = `<svg class="heart-filled" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M26 1H6a1 1 0 0 0-1 1v28a1 1 0 0 0 1.625.781L16 23.28l9.375 7.5A1 1 0 0 0 27 30V2a1 1 0 0 0-1-1z" fill="#000000" opacity="0.5" data-original="#000000"></path>
            </g>
            </svg>`;
    } else {
      wishlistData = wishlistData.filter(
        (item) => item.productTitle !== pdpData.productTitle
      );
      localStorage.setItem("wishlist", JSON.stringify(wishlistData));
      // alert('Product removed from wishlist:', pdpData.productTitle);
      wishlistButton.innerHTML = `<svg class="heart-outline" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                    <g><path d="M26 31a1 1 0 0 1-.625-.219L16 23.28l-9.375 7.5A1 1 0 0 1 5 30V2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v28a1 1 0 0 1-1 1ZM16 21a1 1 0 0 1 .625.219l8.375 6.7V3H7v24.919l8.375-6.7A1 1 0 0 1 16 21Z" fill="#000000" opacity="0.5" data-original="#000000" class="">
                    </path>
                    </g>
                  </svg>`;
    }
    displayWishlist();
  }
});
function toggleWishlist() {
  return;
}

// Remove the specified product from the wishlist
function removeFromWishlist(productTitle) {
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlistData = wishlistData.filter(
    (item) => item.productTitle !== productTitle
  );
  localStorage.setItem("wishlist", JSON.stringify(wishlistData));
  // Update the display after removing from the wishlist
  displayWishlist(wishlistData);
}

// Display wishlist items
 function displayWishlist(pdpData) {
        const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
      const wishlistBlock = document.querySelector('.js-wishlistBlock');

          if (!wishlistBlock) return;
        
        var wishlistHtml = ''
        if (wishlistData.length == 0) {
            // console.log('Wishlist is empty');
            wishlistBlock.innerHTML = wishlistHtml;
            // console.log('Wishlist 0');
          
            return;
        }else{
          wishlistBlock.innerHTML = wishlistData.map(item => `
            <div class="wishlist-product__list">
                <div class="c-product">       
                <a href="${item.productUrl}">
                    <img src="${item.productImg}" alt="${item.productTitle}">
                    </a>
                    <h3 class="c-product__title card__heading h5">
                        <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
                    </h3>
                    <p class="price">${item.productPrice}</p>
                     <button onclick="removeFromWishlist('${item.productTitle}')" class="wishlist-btn">
                      <svg class="heart-filled" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M26 1H6a1 1 0 0 0-1 1v28a1 1 0 0 0 1.625.781L16 23.28l9.375 7.5A1 1 0 0 0 27 30V2a1 1 0 0 0-1-1z" fill="#000000" opacity="0.5" data-original="#000000"></path>
                </g>
                </svg>
                      </button>
                </div>
            </div>`).join('');
      
        }
    }

// Execute this function on DOM content load
document.addEventListener("DOMContentLoaded", function () {
  // Fetch the wishlist data from localStorage
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  // Set the initial button text based on whether the product is in the wishlist or not
  const wishlistButton = document.querySelector(".wishlist_button"); // Use querySelector instead of getElementsByClassName
  const productTitle = "{{ product.title }}";

  if (wishlistButton) {
    const isAlreadyInWishlist = wishlistData.some(
      (item) => item.productTitle == productTitle
    );
    wishlistButton.innerHTML = isAlreadyInWishlist
      ? `<svg class="heart-filled" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M26 1H6a1 1 0 0 0-1 1v28a1 1 0 0 0 1.625.781L16 23.28l9.375 7.5A1 1 0 0 0 27 30V2a1 1 0 0 0-1-1z" fill="#000000" opacity="1" data-original="#000000"></path>
            </g>
            </svg>`
      : `<svg class="heart-outline" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                    <g><path d="M26 31a1 1 0 0 1-.625-.219L16 23.28l-9.375 7.5A1 1 0 0 1 5 30V2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v28a1 1 0 0 1-1 1ZM16 21a1 1 0 0 1 .625.219l8.375 6.7V3H7v24.919l8.375-6.7A1 1 0 0 1 16 21Z" fill="#000000" opacity="1" data-original="#000000" class="">
                    </path>
                    </g>
                  </svg>
`;
  } else {
  }

  // Display wishlist items
  displayWishlist();
});
